/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import styles from './progress-bar.css';


const ProgressBar = ({
  percentage,
  description,
  className,
}) => {
  const fill = (percentage > 100) ? 100 : (percentage < 0) ? 0 : percentage;

  return (
    <div className={className || ''}>
      <div className={styles.progressBar}>
        <div className={styles.fill} style={{ width: `${fill}%` }} />
      </div>
      {description && (
        <div className={styles.description}>
          {description}
        </div>
      )}
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default ProgressBar;
